import styles from './OrganizationItem.module.scss';

import { AssignmentViewModel } from 'chaika-frontend-types/frontend-cms';

import { FieldTitle, FieldTitleTheme } from '@components/FieldTitle';
import { Icon, IconType } from '@components/Icon';
import { OptionType, Select } from '@components/Select';
import { useHandlers } from '@common/CreationMenuFields/OrganizationAssignment/OrganizationItem/hooks/useHandlers';
import { DurationForm } from '@components/DurationForm';
import { translate } from '@chaika/i18n/helper';

interface Props {
    item: AssignmentViewModel;
    selectedIds: string[];
    options: OptionType<string>[];
    dataTest: string;
    onChange(item: Partial<AssignmentViewModel>): void;
    onDelete(): void;
}

export const OrganizationItem = ({ dataTest, item, options, onChange, onDelete, selectedIds = [] }: Props) => {
    const { onItemChange, onDateChange } = useHandlers({ onChange, selectedIds });

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <FieldTitle
                    theme={FieldTitleTheme.WithFlex}
                    title={translate('organization')}
                />
                <div
                    className={styles.delete}
                    onClick={onDelete}
                >
                    <Icon type={IconType.TRASH_REDESIGN} />
                </div>
            </div>
            <div className={styles.selectors}>
                <Select
                    isClearable
                    isSearchable
                    hideSelectedOptions
                    placeholder={translate('chooseFromList')}
                    selectedValue={item.organizationId}
                    options={options}
                    onChange={onItemChange}
                    dataTest={`${dataTest}_select`}
                />
                <DurationForm
                    withoutDurationSelect
                    isClearable
                    isStartDateClearable
                    startDate={!!item.startDate ? new Date(item.startDate) : undefined}
                    endDate={!!item.endDate ? new Date(item.endDate) : undefined}
                    onDateChange={onDateChange}
                />
            </div>
        </div>
    );
};
